import { CompanyLinkType } from '@api';
import {
  EmailAnchor,
  PhoneNumberAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { CompanyLinkTableRowType } from '../../types';
import { useGetRowValues } from './hooks';

type CompanyLinkTableRowPropsType = {
  companyLink: CompanyLinkType;
  row: CompanyLinkTableRowType;
};

export const CompanyLinkTableRow: React.FC<CompanyLinkTableRowPropsType> = ({
  companyLink,
  row,
}) => {
  const { t } = useTranslation('personDetailsGeneral');
  const { getRowValues } = useGetRowValues(companyLink);

  const label = t(
    `COMPANY_LINKS.COMPANY_LINK_CARD.COMPANY_LINK_TABLE.ROWS.${row.label}`
  );
  const value = getRowValues(row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'contact.mobile':
      case 'contact.phone':
        return <PhoneNumberAnchor phoneNumber={value} />;
      case 'contact.email':
        return <EmailAnchor email={value} />;
      default:
        return value;
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
